<mat-card class="unauthorised-error">
  <span>{{ errorMessage }}</span>
</mat-card>
